import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["active", "open"]
const _hoisted_2 = { class: "tt-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, null, -1)

import {ref} from "vue";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: ["message", "open"],
  setup(__props) {

    
    const ttVisible = ref();

    function toggleTooltip() {
        //ttVisible.value = !ttVisible.value;
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: "tooltip tooltip-icon",
    onClick: toggleTooltip,
    active: ttVisible.value,
    open: __props.open
  }, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.message), 1)
      ]),
      _hoisted_3
    ])
  ], 8, _hoisted_1))
}
}

})